import { DimensionStatus } from "../../../store/dimension.status";

export const processDimensionStatus = (
    status: DimensionStatus,
    optional?: boolean,
): DimensionStatus => {
    if (optional) return DimensionStatus.SUCCESS;
    return status;
};
